import { TextInput, maxLength, required, useTranslate } from "react-admin";
import { useWatch } from "react-hook-form";

const validateDestination = [required(), maxLength(100)];
const validateAddress = [required(), maxLength(500)];
const validateAddress2 = [maxLength(500)];
const validatePhone = [required(), maxLength(20)];

const DeliveryNote = (props) => {
  const dependOnType = useWatch({ name: "type" });
  const t = useTranslate();
  return dependOnType === 4 ? (
    <>
      <TextInput
        variant="outlined"
        source="destination"
        label="mine.label.destination"
        fullWidth
        validate={validateDestination}
        {...props}
      />
      <TextInput
        variant="outlined"
        source="address1"
        label={t("mine.label.address") + " 1"}
        fullWidth
        validate={validateAddress}
        {...props}
      />
      <TextInput
        variant="outlined"
        source="address2"
        label={t("mine.label.address") + " 2"}
        fullWidth
        validate={validateAddress2}
        {...props}
      />
      <TextInput
        variant="outlined"
        source="phone"
        label="mine.label.phone"
        fullWidth
        validate={validatePhone}
        {...props}
      />
    </>
  ) : null;
};

export default DeliveryNote;
